
export const calculateKilometers = async (origin, destination, waypoints = []) => {
    if (!window.google) return;
    const { latitude: originLat, longitude: originLng } = origin;
    const { latitude: destinationLat, longitude: destinationLng } = destination;

    const directionService = new window.google.maps.DirectionsService();
    try {
        const result = await directionService.route({
            origin: { lat: Number(originLat), lng: Number(originLng) },
            destination: { lat: Number(destinationLat), lng: Number(destinationLng) },
            travelMode: 'DRIVING',
            waypoints
        });
        // Calcular la distancia
        const route = result.routes[0];
        let totalDistance = 0;
        route.legs.forEach((leg) => {
            totalDistance += leg.distance.value; // Distancia en metros
        });
        return (totalDistance / 1000).toFixed(1)
    } catch (error) {
        return error
    }
}

export const roundPrice = (valor) => {
    let parteDecimal = valor % 1; if (parteDecimal < 0.5) {
        return Math.ceil(valor * 20) / 20;
    }

    if (parteDecimal >= 0.5) {
        return Math.ceil(valor);
    }
    return valor;
}